var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarIsHost(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24268_11467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7Z",
    fill: "#FF3F97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99987 2.1001L8.29587 5.2161L11.6599 5.4861L9.09687 7.6801L9.87987 10.9631L6.99987 9.2051L4.11987 10.9651L4.90287 7.6811L2.33887 5.4861L5.70387 5.2161L6.99987 2.1001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24268_11467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIsHost);
export default __webpack_public_path__ + "static/media/star-is-host.07864431.svg";
export { ForwardRef as ReactComponent };